import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../main/components/Header';

const AuthError: React.FC = (containerProps) => {
    const { t } = useTranslation();

    return (
        <div className={classNames(['grid-container', 'padding-bottom-4', 'service-inclusive', 'tyres'])}>
            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                <Header title={t('signin:errorMessages.authenticationFailed')} />
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <div className={'margin-top-2'}>
                        <p>{t('signin:errorMessages.authFailed.text1')}</p>
                        <p>{t('signin:errorMessages.authFailed.text2')}</p>
                        <p className={'text-bold'}>{t('signin:errorMessages.authFailed.text3')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthError;
